// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

//TEMP, remove once the DEBUG navigate is removed
import { Router } from '@angular/router';
//TEMP

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
//import { FormDataService2 } from '../../shared/services/formData2';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';

//Config/Globals
import { Enums } from '../../shared/enums.js';

//Token
import { authToken } from '../../shared/authToken';

//Classes
import { FormAction } from "../../shared/classes/formAction";



// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CometPlannerViewComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    styles : ['.comet-main-content-div{position:absolute;top:0;right:0;bottom:0;left:0px;display:flex;flex-direction:column;min-width:450px}.comet-main-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0 8px 10px 8px;padding:0 8px;background-color:#eee;border:solid 1px #ddd;border-radius:4px}.comet-filter-control-div{flex-grow:0;display:flex;align-items:center;margin:0 8px 10px 8px;padding:0 8px;border-radius:4px}.comet-legend-item-div{margin:0 16px 0 2px}.comet-main-grid-div{flex-grow:1;position:relative;margin-top:15px;border-top:solid 1px #ccc}.comet-control-lbl{margin-right:4px}.comet-filter-radio{padding-left:10px;display:flex;align-items:center}.comet-main-control-break{flex-basis:100%;height:0}.comet-ui-popup-implementation-detail{width:625px;max-width:625px}.comet-cssClasses_Grid{border-top:solid 1px #bbb}.comet-cssClasses_Cell{border-right:solid 1px #ccc;padding:2px 4px !important;margin:0}.comet-cssClasses_EditableCell_incomplete{border:solid 1px orange !important}.comet-cssClasses_EditableCell_complete{border:solid 1px green !important}'],
    template : '<!--Content Div-->\n<div class="comet-main-content-div" data-test-id="content_comet_view">\n\n    <!-- ---------------------------------------------------- -->\n    <!-- Title -->\n    <!-- ---------------------------------------------------- -->\n    <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n    <div class="cpd-subtitle-div">Read Only</div>\n\n    <!--Content Loading -->\n    <div *ngIf="casNavBoxService.ActionsLoading || _pageLoading" class="cpd-ui-content-loading">\n        <img src="public/cpd-images/loading.gif" />\n        <div style="margin-left:10px;">Loading...</div>\n    </div>\n\n    <!--CONTENT CONTAINER (hidden during loading operations)-->\n    <ng-container *ngIf="!_pageLoading">\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Control Div -->\n        <!-- ---------------------------------------------------- -->\n        <div class="comet-main-control-div">\n\n            <!--STATE-->\n            <div class="cpd-control-unit">\n\n                <label *ngIf="!this._isState" class="comet-control-lbl">State: <span class="cpd-required">*</span></label>\n                <select *ngIf="!this._isState" id="selState" [(ngModel)]="_selectedState" (change)="stateChanged($event)" aria-label="select state" aria-required="true">\n                    <option *ngFor="let state of _states;" [ngValue]="state">{{state.state_name_display}}</option>\n                </select>\n\n                <div style="width:20px;"></div>\n            </div>\n\n            <!--COUNTY-->\n            <div *ngIf="this._selectedStateCode != \'\'" class="cpd-control-unit">\n\n                <label class="comet-control-lbl">County: </label>\n                <select id="selCounty" [(ngModel)]="_selectedCounty" (change)="countyChanged($event)" aria-label="select county">\n                    <option *ngFor="let county of _counties;" [ngValue]="county">{{county.county_name}}</option>\n                </select>\n\n                <div style="width:20px;"></div>\n            </div>\n\n            <!--MANAGEMENT CLASS-->\n            <div *ngIf="this._selectedStateCode != \'\'" class="cpd-control-unit">\n\n                <label class="comet-control-lbl">Management Class: </label>\n                <select id="selManagementClass" [(ngModel)]="_selectedManagementClass" (change)="managementClassChanged($event)" aria-label="select management class">\n                    <option *ngFor="let management_class of _managementClasses;" [ngValue]="management_class">{{management_class.management_class}}</option>\n                </select>\n\n                <div style="width:20px;"></div>\n            </div>\n\n            <!--GO BUTTON -->\n            <div *ngIf="this._selectedStateCode != \'\'" class="cpd-control-unit">\n                <button type="button" class="btn btn-primary" [disabled]="!_goButtonOn || _disableControls" (click)="goButtonClicked()">GO</button>\n            </div>\n\n        </div>\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Grid Div -->\n        <!-- ---------------------------------------------------- -->\n        <div class="comet-main-grid-div">\n            <cas-grid #mainGrid\n                      summary="{{_title}}"\n                      [settings]="_mainGridSettings"\n                      (onRowSelectionChanged)="gridRowSelected()"\n                      (onRefreshClicked)="gridRefreshClicked()"\n                      (onSearch)="onGridSearch($event)">\n            </cas-grid>\n        </div>\n\n        <!--POPUP INSTANCE CONTAINER-->\n        <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n        where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n        are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n        <div id="comet_planner_page_popups"></div>\n        \n        <!--========================================-->\n        <!-- Implementation Detail Popup -->\n        <!--========================================-->\n        <modal #popImplementationDetails\n               title={{_popupTitle}} \n               containerId="comet_planner_page_popups"\n               label="popImplementationDetails">\n\n            <!--FVT-ID-->\n            <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_comet_implementation_detail"></section>\n\n            <!-- body -->\n            <section>\n\n                <div class="cpd-ui-row">\n                    <div class="cpd-ui-cell" style="width:100%">\n\n                        <div class="cpd-ui-group-lbl" role="heading" aria-level="5">Details</div>\n\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 40px; text-align: left; " title="Asset Name">Asset:</label>\n                            <label style="width: 340px; text-align: left;">{{this._popupImplementationValues.assetName}}</label>\n                        </div>\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 40px; text-align: left; "title="Asset Code">Code:</label>\n                            <label style="width: 140px; text-align: left;">{{this._popupImplementationValues.assetCode}}</label>\n                            <label style="width: 140px; text-align: left; margin-left: 30px;"title="Sample size for COMET-Farm\nmodeled practices">Sample Size:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.sampleSize}}</label>\n                        </div>\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 40px; text-align: left; "title="County Name">County:</label>\n                            <label style="width: 140px; text-align: left;">{{this._popupImplementationValues.countyName}}</label>\n                            <label style="width: 140px; text-align: left; margin-left: 30px;" title="Irrigated">Irrigated:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.irrigated}}</label>\n                        </div>\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 40px; text-align: left; " title="Broad class of conservation practice">Class:</label>\n                            <label style="width: 140px; text-align: left;">{{this._popupImplementationValues.managementClass}}</label>\n                            <label style="width: 140px; text-align: left; margin-left: 30px;" title="USDA Land Resource Region\nrectified to county boundaries">Land Resource Region:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.landResourceRegion}}</label>\n                        </div>\n\n                    </div>\n                </div>\n\n                <div class="cpd-ui-row">\n                    <div class="cpd-ui-cell" style="width:100%">\n\n                        <div class="cpd-ui-group-lbl" role="heading" aria-level="5" style="padding-top:2px;">CO<sub style="font-size:9px;">2</sub></div>\n\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 140px; text-align: left;"title="Mean total carbon dioxide\n(CO2) emission reductions\n(sum of all CO2 sources)">Mean:</label>\n                            <label style="width: 40px; text-align:right;">{{this._popupImplementationValues.co2Mean}}</label>\n                            <label style="width: 140px; text-align: left; margin-left: 30px;" title="Mean carbon dioxide (CO2)\nemissions reductions from fossil\nenergy use in farm equipment">Fossil:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.co2Fossil}}</label>\n                        </div>\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 140px; text-align: left; " title="Mean carbon dioxide (CO2) emissions\nreductions from soil carbon">Soil Carbon:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.co2SoilCarbon}}</label>\n                            <label style="width: 140px; text-align: left; margin-left: 30px; " title="Mean carbon dioxide (CO2)\nemissions reductions from liming">Liming:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.co2Liming}}</label>\n                        </div>\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 140px; text-align: left; " title="Mean carbon dioxide (CO2) emissions\nreductions from drained organic soils">Drained Organic Soils:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.co2DrainedOrganicSoils}}</label>\n                            <label style="width: 140px; text-align: left; margin-left: 30px; " title="Minimum of total greenhouse\ngas emission reductions">Total GHG Min:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.co2GHGMin}}</label>\n                        </div>\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 140px; text-align: left; " title="Mean carbon dioxide (CO2) emissions\nreductions from biomass carbon">Biomass:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.co2Biomass}}</label>\n                            <label style="width: 140px; text-align: left; margin-left: 30px; " title="Maximum of total greenhouse\ngas emission reductions">Total GHG Max:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.co2GHGMax}}</label>\n                        </div>\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 140px; text-align: left; " title="Mean carbon dioxide (CO2) emissions\nreductions from biomass burning">Biomass Burning:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.co2BiomassBurning}}</label>\n                            <label style="width: 140px; text-align: left; margin-left: 30px; "title="Mean of total greenhouse\ngas emission reductions">Total GHG:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.co2GHG}}</label>\n                        </div>\n                    </div>\n                </div>\n\n                <div class="cpd-ui-row">\n                    <div class="cpd-ui-cell" style="width:100%">\n\n                        <div class="cpd-ui-group-lbl" role="heading" aria-level="5" style="padding-top:2px;">N<sub style="font-size:9px;">2</sub>O</div>\n\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 140px; text-align: left; " title="Mean total nitrous oxide (N2O)\nemission reductions (sum of\nall N2O emission sources)">Mean:</label>\n                            <label style="width: 40px; text-align: right; ">{{this._popupImplementationValues.n2oMean}}</label>\n                            <label style="width: 140px; text-align: left; margin-left: 30px; " title="Mean nitrous oxide (N2O) emissions\nreductions from drained organic soils">Drained Organic Soils:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.n2oDrainedOrganicSoils}}</label>\n                        </div>\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 140px; text-align: left; " title="Mean nitrous oxide (N2O) emissions\nreductions from direct soil N2O">Direct Soil:</label>\n                            <label style="width: 40px; text-align: right; ">{{this._popupImplementationValues.n2oDirectSoil}}</label>\n                            <label style="width: 140px; text-align: left; margin-left: 30px;" title="Mean nitrous oxide (N2O) emissions\nreductions from indirect soil N2O\n(volatilization and leaching)">Indirect Soil:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.n2oIndirectSoil}}</label>\n                        </div>\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 140px; text-align: left; " title="Mean nitrous oxide (N2O) emissions\nreductions from biomass burning">Biomass Burning:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.n2oBiomassBurning}}</label>\n                        </div>\n                    </div>\n                </div>\n\n                <div class="cpd-ui-row" style="padding-bottom: 2px;">\n                    <div class="cpd-ui-cell" style="width:100%">\n\n                        <div class="cpd-ui-group-lbl" role="heading" aria-level="5" style="padding-top:2px;">CH<sub style="font-size:9px;">4</sub></div>\n\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 140px; text-align: left; " title="Mean total methane (CH4)\nemission reductions (sum of\nall CH4 emission sources)">Mean:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.ch4Mean}}</label>\n                            <label style="width: 140px; text-align: left; margin-left:30px;" title="Mean methane (CH4) emissions\nreductions from biomass burning">Biomass Burning:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.ch4BiomassBurning}}</label>\n                        </div>\n                        <div class="cpd-ui-field-div">\n                            <label style="width: 140px; text-align: left;" title="Mean methane (CH4) emission\nreductions from soil">Soil:</label>\n                            <label style="width: 40px; text-align: right;">{{this._popupImplementationValues.ch4Soil}}</label>\n                        </div>\n\n                    </div>\n                </div>\n                <div class="cpd-ui-field-div">*All measurements in MT CO<sub style="font-size:9px;">2</sub>e/ac/yr</div>\n\n            </section>\n\n            <!-- footer -->\n            <footer>\n                <button type="button" class="btn btn-secondary" (click)="popImplementationDetails.Close()">Close</button>\n            </footer>\n\n        </modal>\n\n\n\n    </ng-container>\n\n</div>\n',
    providers: [],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})

export class CometPlannerViewComponent implements OnInit {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('mainGrid') mainGrid;
    @ViewChild('popImplementationDetails') popImplementationDetails;

	//Class wide member reference for the growls control
	growlBox = null;


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _authToken = authToken; //authToken sometimes acts weird sometimes if you don't assign it locally

    //Boiler Plate
    _componentName = 'cometPlannerView.js';
    _disableControls = false;
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _formName = 'comet'; //Just a shortcut (also helpful for cut & paste)
    _pageLoading = true;
    _sessionStorageObject = null;
    _title = "COMET Planner";
    _popupTitle = "COMET Planning Implementation Details";

    //Data
    _selectedRow = null;
    _states = [];
    _selectedState = "";
    _selectedStateCode = "";
    _counties = [];
    _selectedCounty = "";
    _managementClasses = [];
    _selectedManagementClass = "";
    _isState = false;

    //UI Indicators
    _goButtonOn = false;

    //Temporarily holds objects used to represent what is being viewed in the popup
    _popupImplementationValues = {

        assetCode: "",
        assetName: "",
        countyName: "",
        managementClass: "",
        irrigated: false,
        sampleSize: null,
        landResourceRegion: false,
        co2Mean: null,
        co2SoilCarbon: null,
        co2BiomassBurning: null,
        co2Biomass: null,
        co2DrainedOrganicSoils: null,
        co2Fossil: null,
        co2Liming: null,
        co2GHGMin: null,
        co2GHGMax: null,
        co2GHG: null,
        n2oMean: null,
        n2oBiomassBurning: null,
        n2oDirectSoil: null,
        n2oIndirectSoil: null,
        n2oDrainedOrganicSoils: null,
        ch4Mean: null,
        ch4BiomassBurning: null,
        ch4Soil: null
    }

    //Main Grid
    _mainGridSettings = {
        hideClearSelectedButton: true,
        hideSearchBox: false,
        positionAbsolute: true,
        rows: [],
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "practice_code",
        rowIdentityPrefixForJAWS: "Code",
        cssClasses_Grid: "comet-cssClasses_Grid",
        cssClasses_Cell: "comet-cssClasses_Cell",
        columns: [
            { fieldName: 'practice_code', display: 'Code', width: '7%', minWidth: 25 },
            { fieldName: 'practice_display', display: 'Asset', width: '20%', minWidth: 100 },
            { fieldName: 'county_name', display: 'County Name', width: '12%', minWidth: 50 },
            { fieldName: 'management_class', display: 'Mgmt Class', width: '14%', minWidth: 25, columnHeaderToolTip: "Broad class of conservation practice" },
            { fieldName: 'implementation_name', display: 'Implementation Name', width: '45%', minWidth: 100, columnHeaderToolTip: "The implementation scenario modeled for" + "\n" + "each conservation practice standard" }]
        };

    //Main Grid
    //This grid includes data values. Keeping for now just in case
    //_mainGridSettings = {
    //    hideClearSelectedButton: true,
    //    hideSearchBox: false,
    //    positionAbsolute: true,
    //    rows: [],
    //    rowIdentifyForJAWS: true,
    //    rowIdentityFieldForJAWS: "practice_code",
    //    rowIdentityPrefixForJAWS: "Code",
    //    cssClasses_Grid: "comet-cssClasses_Grid",
    //    cssClasses_Cell: "comet-cssClasses_Cell",
    //    columns: [
    //        { fieldName: 'practice_code', display: 'Code', width: '7%', minWidth: 25 },
    //        { fieldName: 'practice_display', display: 'Asset', width: '20%', minWidth: 100 },
    //        { fieldName: 'county_name', display: 'County Name', width: '12%', minWidth: 50 },
    //        { fieldName: 'management_class', display: 'Mgmt Class', width: '15%', minWidth: 25, columnHeaderToolTip: "Broad class of conservation practice" },
    //        { fieldName: 'irrigated', display: 'Irrigated', width: '6%', minWidth: 20 },
    //        { fieldName: 'sample_size', display: 'Sample Size', width: '7%', minWidth: 20, columnHeaderToolTip: "Sample size for COMET-Farm modeled practices" },
    //        { fieldName: 'lrr_fill', display: 'Land Resource Region', width: '8%', minWidth: 25, columnHeaderToolTip: "USDA Land Resource Region rectified to county boundaries" },
    //        { fieldName: 'co2_mean', display: 'CO2 Mean', width: '6%', minWidth: 20, columnHeaderToolTip: "Mean total carbon dioxide (CO2) emission reductions" + "\n" + "(sum of all CO2 sources) in metric tonnes CO2 equivalent" + "\n" + "per acre per year (MT CO2e/ac/yr)" },
    //        { fieldName: 'n2o_mean', display: 'N2O Mean', width: '6%', minWidth: 20, columnHeaderToolTip: "Mean total nitrous oxide (N2O) emission reductions" + "\n" + "(sum of all N2O emission sources) in metric tonnes CO2" + "\n" + "equivalent per acre per year (MT CO2e/ac/yr)" },
    //        { fieldName: 'ch4_mean', display: 'CH4 Mean', width: '6%', minWidth: 20, columnHeaderToolTip: "Mean total methane (CH4) emission reductions (sum of" + "\n" + "all CH4 emission sources) in metric tonnes CO2 equivalent" + "\n" + "per acre per year (MT CO2e/ac/yr)" }]
    //};

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService,
        cpdFormatters: CPDFormatters,
        domSanitizer: DomSanitizer,
        //formDataService: FormDataService2,
        helpers: Helpers,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

		// Growl Prep
		//--------------------
		this.growlBox = new BCGrowls("growlBox");
		this.growlBox.init({ 
			appendToElementId:"cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
		}); 

        //Handle clicks on the NavBox actions via the navBoxCommService
        let disposer = casNavBoxService.OnActionClicked$.subscribe(action => {
            this.navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        // Set state variables
        //--------------------
        if (this._authToken.IsState()) {
            this._isState = true;
            this._title = this._authToken.user.stateName + " - COMET Planner";
            this._selectedStateCode = this._authToken.user.stateCode;
        }
        else {
            this._title = "COMET Planner";
        }

        this._disableControls = false;
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {

        console.log("\n[{0}:ngOnInit()]------------------------------------------------------------------------".format(this._componentName));

        //508
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);

        // Load the form fields
        //-----------------------------------
        this.casNavBoxService.ActionsLoading = true;

        let actions = [];
        actions.push(new FormAction("act_implementation_details", "Implementation Details"));
        console.log("[{0}:ngOnInit()] - actionLinks:".format(this._componentName, this._formName), actions);

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;

        // If state, load county and management class filters and comet grid for that state, otherwise load state dropdown
        if (this._isState) {
            this.initStates(() => {

                this.initCounties(() => {
                    this.initManagementClasses(() => {
                        this.initCometGrid(() => {
                            this.ngOnInit_Complete();
                        });
                    });
                });
            });
        }
        else {
            this.initStates(() => {

                this.ngOnInit_Complete();
            });
        }
    };

    //=======================================
    // ngOnInit_Complete
    //=======================================
    // Called once all the async work in onInit is complete
    ngOnInit_Complete() {

        this._goButtonOn = true;
        this._pageLoading = false;
    };

    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {

        switch (action.field_name.toLowerCase()) {

            case "act_implementation_details":
                if (!this._selectedRow) {
                    this.growlBox.addGrowl("info", "Please select a row to edit");
                    return;
                }

                this.action_openImplementationDetails();
                break;

        }

    };


    //==================================
    //  onGridSearch
    //==================================
    onGridSearch(searchText) {

        //console.log("onGridSearch", event);

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0) {
            this.mainGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return row.practice_code.toLowerCase().indexOf(searchText) >= 0 || row.practice_display.toLowerCase().indexOf(searchText) >= 0 || row.implementation_name.toLowerCase().indexOf(searchText) >= 0;
        };

        //Set the "search" filter on the grid
        this.mainGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    }

    //==================================
    // gridRefreshClicked
    //==================================
    gridRefreshClicked() {

        // Refresh grid
        this.goButtonClicked();
    }

    //==================================
    // stateChanged
    //==================================
    stateChanged(e) {
        //Load County and Management Class filter dropdowns and grid
        this.mainGrid.MarkAsLoading(true);
        this._selectedStateCode = this._selectedState.state_code;
        if (this._selectedStateCode != "") {
            this.initCounties(() => {
                this.initManagementClasses(() => {
                    this.initCometGrid(() => {
                        this.ngOnInit_Complete();
                        this.mainGrid.MarkAsLoading(false);
                    });
                });
            });
        }
        //No state is selected, clear grid
        else {
            this.mainGrid.SetRows('');
            this.mainGrid.MarkAsLoading(false);
            this._goButtonOn = true;
        }
    }

    //==================================
    // countyChanged
    //==================================
    countyChanged(e) {
        //Nothing to do at this point as the go button handles executing the change
    }

    //==================================
    // managementClassChanged
    //==================================
    managementClassChanged(e) {
        //Nothing to do at this point as the go button handles executing the change
    }

    //==================================
    // gridRowSelected 
    //==================================
    gridRowSelected(row) {
        //This is called when a row is selected AND unselected, resulting in a "null" selected row when unselected
        //For use in future story
        this._selectedRow = this.mainGrid.GetFirstSelectedRow(); //There will only be one for this single-select grid
    }

    //==================================
    // goButtonClicked
    //==================================
    //  callback<fn>:       //(opt,null)
    goButtonClicked(fnOnComplete) {

        this._goButtonOn = false;
        this.mainGrid.MarkAsLoading(true);

        //Clear any search box filters
        this.mainGrid.ClearFilter("search", false);
        this.mainGrid.ClearSearchBox();

        //Define filters
        let stateCode;
        if (this._isState) {
            stateCode = this._authToken.user.stateCode;
        }
        else {
            stateCode = this._selectedState.state_code;
        }

        let countyCode = this._selectedCounty.county_code != "000" ? this._selectedCounty.county_code : "";
        let managementClass = this._selectedManagementClass.management_class_id;

        //Load the filtered implementation records
        if (stateCode != null) {
            //Filters for county and management class to be included in future story, for now pass null values
            this.loadCometImplementation(stateCode, countyCode, managementClass, (dto) => {

                //Update the grid to show the records (grid should be loaded by the time GO can be clicked)
                this.mainGrid.SetRows(dto);

                //Clean up UI load indicators
                this.mainGrid.MarkAsLoading(false);
                this._goButtonOn = true;

                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }
            });
        }
        //No state is selected, we don't call loadCometImplementation. 
        //Too many records to call without a state filter
        else {
            this.mainGrid.SetRows('');
            this.mainGrid.MarkAsLoading(false);
            this._goButtonOn = true;
            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }

        }
    }

    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    //=======================================
    // initCometGrid
    //======================================
    initCometGrid(fnOnComplete) {

        let stateCode;
        if (this._isState) {
            stateCode = this._authToken.user.stateCode;
        }
        else {
            stateCode = this._selectedState.state_code;
        }

        if (stateCode == "") { throw ("Cannot call initCometGrid() until a state has been selected"); }

        this.loadCometImplementation(stateCode, "", null, (dto) => {

            //Update the grid to show the practices (grid should be loaded by the time GO can be clicked)
            if (this.mainGrid) {
                this.mainGrid.SetRows(dto);
            }
            else {
                this._mainGridSettings.rows = dto;
            }

            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }
        });
    }

    //==================================
    // _setGridRows
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here we'll test and see if we need to change the underlying settings
    // or the loaded object.
    _setGridRows(data) {

        if (this.mainGrid) {
            this.mainGrid.SetRows(data);
        }
        else {
            this._mainGridSettings.rows = data;
        }
    }

    //=======================================
    // loadCometImplementation
    //=======================================
    loadCometImplementation(stateCode, countyCode, managementClassId, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/comet/getImplementations",
            args: {
                stateCode: stateCode,
                countyCode: countyCode,
                managementClassId: managementClassId
            }
        })
            .then(res => {
                console.log("[{0}:/comet/getImplementations] - res:".format(this._componentName), res);
                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                console.log(err);
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //=======================================
    // initStates
    //======================================
    initStates(fnOnComplete) {

        //Load the states
        this.loadStates((dto) => {

            this._states = [{ state_code: "", state_abbreviation: "", state_name_display: "Select State" }].concat(dto);
            if (this._selectedStateCode == "") {
                this._selectedState = this._states[0];
            }

            if (fnOnComplete) { fnOnComplete(); }
        });

    }

    //=======================================
    // initCounties
    //======================================
    initCounties(fnOnComplete) {

        //Load the states
        this.loadCounties((dto) => {

            this._counties = dto;
            this._selectedCounty = this._counties[0];
            if (fnOnComplete) { fnOnComplete(); }
        });

    }

    //=======================================
    // initManagementClasses
    //======================================
    initManagementClasses(fnOnComplete) {

        //Load the states
        this.loadManagementClasses((dto) => {

            this._managementClasses = [{ management_class_id: "", management_class: "All Management Classes" }].concat(dto);
            this._selectedManagementClass = this._managementClasses[0];
            if (fnOnComplete) { fnOnComplete(); }
        });

    }

    //=======================================
    // loadStates
    //=======================================
    loadStates(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/practices/getAllStates"
        })
            .then(res => {
                console.log("[{0}:loadStates():getAllStates()] - res:".format(this._componentName), res);
                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //=======================================
    // loadCounties
    //=======================================
    loadCounties(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/comet/getCountiesForState",
            args: {
                stateCode: this._selectedStateCode
            }
        })
            .then(res => {
                console.log("[{0}:loadCounties():getCountiesForState()] - res:".format(this._componentName), res);
                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //=======================================
    // loadManagementClasses
    //=======================================
    loadManagementClasses(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/comet/getManagementClasses",
        })
            .then(res => {
                console.log("[{0}:loadManagementClasses():getManagementClasses()] - res:".format(this._componentName), res);
                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //=======================================
    // action_openImplementationDetails
    //=======================================
    action_openImplementationDetails() {

        //Make sure a row was selected
        let selectedImplementation = this.mainGrid.GetFirstSelectedRow();
        if (!selectedImplementation) {
            this.growlBox.addGrowl("error", "Please select an implementation to view.");
            return;
        }

        this._popupTitle = selectedImplementation.implementation_name;

        //Prep the temp object for viewing
        this._popupImplementationValues = {
            assetCode: selectedImplementation.practice_code,
            assetName: selectedImplementation.practice_display,
            countyName: selectedImplementation.county_name,
            managementClass: selectedImplementation.management_class,
            irrigated: selectedImplementation.irrigated ? 'Y' : 'N',
            sampleSize: selectedImplementation.sample_size == null ? '--' : selectedImplementation.sample_size,
            landResourceRegion: selectedImplementation.lrr_fill ? 'Y' : 'N',
            co2Mean: selectedImplementation.co2_mean == null ? '--' : selectedImplementation.co2_mean,
            co2SoilCarbon: selectedImplementation.soil_carbon_co2 == null ? '--' : selectedImplementation.soil_carbon_co2,
            co2BiomassBurning: selectedImplementation.biomassburning_co2 == null ? '--' : selectedImplementation.biomassburning_co2,
            co2Biomass: selectedImplementation.biomass_co2 == null ? '--' : selectedImplementation.biomass_co2,
            co2DrainedOrganicSoils: selectedImplementation.drainedorganicsoils_co2 == null ? '--' : selectedImplementation.drainedorganicsoils_co2,
            co2Fossil: selectedImplementation.fossil_co2 == null ? '--' : selectedImplementation.fossil_co2,
            co2Liming: selectedImplementation.liming_co2 == null ? '--' : selectedImplementation.liming_co2,
            co2GHGMin: selectedImplementation.total_ghg_co2_min == null ? '--' : selectedImplementation.total_ghg_co2_min,
            co2GHGMax: selectedImplementation.total_ghg_co2_max == null ? '--' : selectedImplementation.total_ghg_co2_max,
            co2GHG: selectedImplementation.total_ghg_co2 == null ? '--' : selectedImplementation.total_ghg_co2,
            n2oMean: selectedImplementation.n2o_mean == null ? '--' : selectedImplementation.n2o_mean,
            n2oBiomassBurning: selectedImplementation.biomassburning_n2o == null ? '--' : selectedImplementation.biomassburning_n2o,
            n2oDirectSoil: selectedImplementation.direct_soil_n2o == null ? '--' : selectedImplementation.direct_soil_n2o,
            n2oIndirectSoil: selectedImplementation.indirect_soil_n2o == null ? '--' : selectedImplementation.indirect_soil_n2o,
            n2oDrainedOrganicSoils: selectedImplementation.drainedorganicsoils_n2o == null ? '--' : selectedImplementation.drainedorganicsoils_n2o,
            ch4Mean: selectedImplementation.ch4_mean == null ? '--' : selectedImplementation.ch4_mean,
            ch4BiomassBurning: selectedImplementation.biomassburning_ch4 == null ? '--' : selectedImplementation.biomassburning_ch4,
            ch4Soil: selectedImplementation.soil_ch4 == null ? '--' : selectedImplementation.soil_ch4
        };

        this.popImplementationDetails.Open();
       
    }


}